import { sha256 } from 'js-sha256'
import { sprig } from '@sprig-technologies/sprig-browser/core'

import Config from 'APP/Config'
import I18n from 'APP/I18n'

class _Sprig {
  sprigInstance?: WindowSprig

  constructor() {
    this.init()
  }

  init(): void {
    // configure returns an instance with all the api functions
    const object = sprig.configure({ environmentId: Config.SPRIG_ENV_ID })
    if (object) {
      object.setAttribute('brand_id', Config.BRAND_ID)
      object.setAttribute('lng', I18n.baseLocale)
      this.sprigInstance = object
    }
  }

  track(eventName: string, properties?: SprigProperties): void {
    if (!eventName) return
    // Troubleshooted with a Sprig's engineer.
    // Turns out the track function with callback is not supported until its next release / fix.
    this.sprigInstance?.track(eventName, properties)
  }

  setVisitorAttribute(key: string, value: string): void {
    this.sprigInstance?.setAttribute(key, value)
  }

  setUserIdentifier(userId: number): void {
    this.sprigInstance?.setUserId(sha256(userId.toString()))
  }

  logout(): void {
    this.sprigInstance?.logoutUser()
  }
}

const sprigClient = new _Sprig()

export default sprigClient
